<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Edit Backup Schedule</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="backup_schedule.name">
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" v-model="backup_schedule.enabled">
              Enabled
            </label>
          </div>
          <div class="form-group">
            <label>Time</label> <br>
            <input type="text" class="form-control" v-model="backup_schedule.schedule_time_formatted">
            <small class="form-text text-muted">Must be of the the format hh:mm:ss (am or pm). Example: 10:00:00 am
            </small>
          </div>
          <div class="form-group">
            <label for="ddlFrequency">Frequency</label>
            <select class="form-control" id="ddlFrequency" v-model="backup_schedule.backup_frequency_id">
              <option v-for="backup_frequency in backup_frequencies"
                      :key="backup_frequency.backup_frequency_id"
                      v-bind:value="backup_frequency.backup_frequency_id">{{ backup_frequency.name
                }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlLocation">Location</label>
            <select class="form-control" id="ddlLocation" v-model="backup_schedule.backup_location_id">
              <option value="0">Select..</option>
              <option v-for="backup_location in backup_locations"
                      :key="backup_location.backup_location_id"
                      v-bind:value="backup_location.backup_location_id">{{ backup_location.name
                }}
              </option>
            </select>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminBARScheduleIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'backup_schedule_id'
  ],
  computed: {
    ...mapGetters({
      backup_schedule: 'singleBackupSchedule',
      backup_locations: 'allBackupLocations',
      backup_frequencies: 'allBackupFrequencies'
    })
  },
  created () {
    this.$store.dispatch('getBackupSchedule', this.backup_schedule_id)
    this.$store.dispatch('getBackupLocations')
    this.$store.dispatch('getBackupFrequencies')
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditBackupSchedule', this.backup_schedule)
    }
  }
}
</script>

<style scoped>

</style>
